import {atom} from 'jotai';

export const failedMailAuthentication = atom(false);
